import React, { useState } from "react";
import {
  DataGrid,
  DataGridProps,
  GridColumnVisibilityModel,
  GridFilterModel,
} from "@mui/x-data-grid";

interface PersistedDataGridProps extends DataGridProps {
  applyFilters?: boolean;
  storageKey?: string;
}

const PersistedDataGrid = (props: PersistedDataGridProps) => {
  const { storageKey, ...dataGridProps } = props;
  const filtersStorageKey = storageKey ? `filters:${storageKey}` : "filters";
  const columnVisibilityStorageKey = storageKey
    ? `columnVisibility:${storageKey}`
    : "columnVisibility";

  let storedFilters;
  let storedColumnVisibility;

  try {
    storedFilters = JSON.parse(localStorage.getItem(filtersStorageKey) || "{}");
    storedColumnVisibility = JSON.parse(
      localStorage.getItem(columnVisibilityStorageKey) || "{}"
    );
  } catch {
    storedFilters = {};
    storedColumnVisibility = {};
  }

  const [filters, setFilters] = useState<GridFilterModel>(storedFilters);
  const [columnVisibility, setColumnVisibility] =
    useState<GridColumnVisibilityModel>(storedColumnVisibility);

  const persistFilters = (newFilters: GridFilterModel) => {
    localStorage.setItem(filtersStorageKey, JSON.stringify(newFilters));
    setFilters(newFilters);
  };

  const persistColumnVisibility = (
    newColumnVisibility: GridColumnVisibilityModel
  ) => {
    localStorage.setItem(
      columnVisibilityStorageKey,
      JSON.stringify(newColumnVisibility)
    );
    setColumnVisibility(newColumnVisibility);
  };

  return (
    <DataGrid
      filterModel={Object.keys(filters).length > 0 ? filters : undefined}
      onFilterModelChange={persistFilters}
      columnVisibilityModel={columnVisibility}
      onColumnVisibilityModelChange={persistColumnVisibility}
      autoHeight
      {...dataGridProps}
    />
  );
};

export default PersistedDataGrid;
